import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { useResources } from 'app/providers/TranslationProvider/hooks/useConfig/hooks';
import { IS_DEVELOPMENT } from 'shared/config/env';
import { useDefaultLocale } from 'shared/hooks/localization';

export const useConfig = () => {
  const resources = useResources();
  const lang = useDefaultLocale();

  // TODO: add new language detector to useDefaultLocale in task PDS-167
  i18n.use(initReactI18next).init({
    lng: lang, // change it in PDS-167
    fallbackLng: lang,
    debug: IS_DEVELOPMENT,
    returnNull: false,
    interpolation: { escapeValue: false },
    detection: { order: ['navigator'] },
    react: {
      transSupportBasicHtmlNodes: true,
    },
    resources,
  });

  return { i18n };
};
